module.exports = __webpack_public_path__ + "img/sti-sc-gray.6e0dd7ae.svg";